import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/RaceGuide.css';

const RaceGuide: React.FC = () => {
  return (
    <div className="race-guide-container">
      <h1>2026 NORTH PARKLEY RACE GUIDE</h1>
      
      <section className="book-drops-announcement">
        <h2>📚 Book Drop Locations Now Available!</h2>
        <p>Check out the complete <Link to="/book-drops">book drop locations guide</Link> with detailed information, photos, and maps for all 8 locations.</p>
      </section>
      
      <section className="registration-details">
        <h2>Registration Details</h2>
        <p>Please be sure to <Link to="/register">register</Link> and choose your distance.</p>
        <p>Entry fee is $3.50. Please bring exact change.</p>
      </section>
      
      <section className="start-finish">
        <h2>Start and Finish Location</h2>
        <p><strong>9990 Grubbs Road, Wexford PA 15090</strong></p>
        <p className="note">(use 9980 for gps, we share a driveway, I'm the 2nd and last house)</p>
        <p>We should have plenty of room for parking, but we can use the McCandless Town Hall at the bottom of the hill for overflow if needed.</p>
      </section>

      <section className="start-time">
        <h2>Start Time</h2>
        <p><strong>Sunday, July 12 at 9:00 am</strong></p>
        <p>Please arrive no later than 8:45 am.</p>
      </section>

      <section className="post-race">
        <h2>Post-Race</h2>
        <p>Finish line festivities will include our nearly-world-famous Whimpy burgers and ice baths. We'll have other snacks and plenty of recovery drinks available. Feel free to hang out as long as you like - there is a shower available or you can just hose off like the cool balls legend himself, Lee.</p>
      </section>

      <section className="event-details">
        <h2>Event Details</h2>
        <p>There will be 8 book drop locations around North Park, numbered 1-8 in the guide below. The race will begin at the address above (Ryan's house) and we'll run as a group down to the intersection of Ingomar and Kummer. At that point, each team will be assigned a direction - clockwise or counterclockwise. Clockwise means you collect the books in order from 1 to 8. Counterclockwise means you go from 8 to 1.</p>
        <p>At each book drop, tear out the page that corresponds to your bib number. Return to the start line after your loop to have your pages verified.</p>
        <p>For those doing two loops, your second loop will be run in the opposite direction, and you'll be assigned a new bib number.</p>
      </section>

      <section className="aid-stations">
        <h2>Aid Stations</h2>
        <p>There will be a water drop roughly 5.5 miles from the start, at book drop 3. You'll also pass the 7/11 just after book drop 6.</p>
      </section>

      <section className="course-map">
        <h2>Book Drop Locations / Course Map</h2>
        <p className="warning">There is no official course map - you'll need to navigate yourself to each book drop.</p>
        <p><strong>Your best option is to use the Allegheny County Trails app.</strong></p>
      </section>

      <section className="book-drops-section">
        <h2>Book Drop Locations</h2>
        <p>View detailed information about all 8 book drop locations including photos, maps, and specific instructions.</p>
        <div className="book-drops-link">
          <Link to="/book-drops" className="book-drops-button">View Book Drop Locations</Link>
        </div>
      </section>

      <section className="race-director">
        <h2>Race Director</h2>
        <p><strong>Ryan Patsko</strong></p>
        <p>ryanpatsko@gmail.com</p>
        <p>724-316-5135</p>
      </section>
    </div>
  );
};

export default RaceGuide; 